import { useEffect, useState } from 'react';
import { renderDataCentreBlocks } from '../../util/BlockUtil';

const Locations = ({
  data,
  global,
  lang,
  width,
  popular_downloads_posts,
  related_content,
  tags,
  dataCenters,
}) => {
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isDomLoaded, setIsDomLoaded] = useState(false);

  useEffect(() => {
    let globalMap = document.getElementsByClassName('global-map');

    if (isSearchActive) {
      globalMap[0].style.filter = 'brightness(0.25)';
    } else {
      if (globalMap.length !== 0) {
        globalMap[0].style.filter = null;
      }
    }
  }, [isSearchActive]);

  return (
    <div
      onLoad={() => setIsDomLoaded(!isDomLoaded)}
      className="location-template"
    >
      {renderDataCentreBlocks({
        data,
        global,
        lang,
        width,
        setIsSearchActive,
        popular_downloads_posts,
        related_content,
        tags,
        dataCenters,
      })}
    </div>
  );
};
export default Locations;
